import React from "react";
import ContributorPage from "../../../components/_shared/ContributorPage";
import { ContributorType } from "../../../shared/constant";

const Artists = () => {
  return <ContributorPage contributorType={ContributorType.ARTIST} />;
};

export default Artists;
